import _typeof from "@babel/runtime/helpers/typeof";
import { useContext } from 'react';
import useSWR from 'swr';
import { configurationContext } from '../contexts';
import { getUrl, colors, consoleLog } from '../utils';
function isValidResponse(response) {
  return Boolean(_typeof(response) === 'object' && (response === null || response === void 0 ? void 0 : response.Success));
}
function logError(isDev, message) {
  consoleLog(isDev, {
    ref: 'PersonalMenu',
    text: "Error loading orisales menu, ".concat(message),
    color: colors.red
  });
}
async function fetchOrisalesMenu(baseUrl, url, options) {
  var isDev = options.isDev;
  try {
    var response = await getUrl(baseUrl, url, options);
    if (isValidResponse(response)) {
      return response;
    }
    logError(isDev, "invalid response ".concat(response));
  } catch (error) {
    logError(isDev, "exception ".concat(error));
  }
  return {
    Message: null,
    Success: false
  };
}
export function useOrisalesLinksQuery(canFetch) {
  var _useContext = useContext(configurationContext),
    isDev = _useContext.isDev,
    globalApiUrl = _useContext.globalApiUrl,
    token = _useContext.token,
    tenant = _useContext.tenant,
    lang = _useContext.lang,
    consultantNumber = _useContext.consultantNumber;
  var delimiter = isDev ? '/' : '?';
  return useSWR(canFetch ? "/applications/personalMenu/orisalesMenu".concat(delimiter, "locale=").concat(lang, "&distNum=").concat(consultantNumber) : null, async function (url) {
    return fetchOrisalesMenu(globalApiUrl, url, {
      token: token,
      tenant: tenant,
      lang: lang,
      isDev: isDev
    });
  });
}